/**
 * Manage domains data
 */
import Ajax from '@/lib/ajax_wrapper'

function domainsPath(companyId) {
  return `/admin/companies/${companyId}/domains`
}

/**
 * Check domain A-Record
 *
 * @returns {promise}
 */
export function checkDomainDnsData(companyId, domain) {
  return Ajax.request({
    url: `${domainsPath(companyId)}/check_domain`,
    method: 'POST',
    data: {domain}
  })
}

/**
 * Check domain connection
 *
 * @returns {promise}
 */
export function checkDomainConnectionData(companyId, domain) {
  return Ajax.request({
    url: `/companies/${companyId}/domains/check_is_connected`,
    method: 'POST',
    data: {domain}
  })
}

/**
 * Search for domains
 *
 * @param {object} page
 * @param {integer} page.number
 * @param {integer} page.perPage
 *
 * @returns {promise}
 */
export function searchDomainsData(companyId, query) {
  return Ajax.request({
    url: `${domainsPath(companyId)}/search_domain?keyword=${query}`
  })
}

/**
 * Read paginated domains
 *
 * @param {object} page
 * @param {integer} page.number
 * @param {integer} page.perPage
 *
 * @returns {promise}
 */
export function createCompanyDomainsInvoiceData(companyId, invoice) {
  return Ajax.request({
    url: `/companies/${companyId}/payments/invoices/domains`,
    method: 'POST',
    data: {invoice}
  })
}

/**
 * Read paginated domains
 *
 * @param {object} page
 * @param {integer} page.number
 * @param {integer} page.perPage
 *
 * @returns {promise}
 */
export function readCompanyDomainsData(companyId, page) {
  return Ajax.request({
    url: `/admin/companies/${companyId}/company_domains`,
    page: page
  })
}

/**
 * Register a domain name
 *
 * @returns {promise}
 */
export function createCompanyDomainData(companyId, domain) {
  return Ajax.request({
    url: `${domainsPath(companyId)}/create_domain`,
    method: 'POST',
    data: domain
  })
}

/**
 * Read a company domain name
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function readCompanyDomainData(companyId, domain) {
  return Ajax.request({
    url: `${domainsPath(companyId)}?name=${domain}`
  })
}

/**
 * Read domain URL forwarder
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function readCompanyDomainForwardingsData(companyId, domain) {
  return Ajax.request({
    url: `${domainsPath(companyId)}/${domain}/url_fowarding`
  })
}

/**
 * Read domain URL forwarder
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function readCompanyDomainForwardingData(companyId, domain, host) {
  return Ajax.request({
    url: `${domainsPath(companyId)}/${domain}/url_fowarding/${host}`
  })
}

/**
 * Delete domain URL forwarder
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function deleteCompanyDomainForwardingData(companyId, domain, host) {
  return Ajax.request({
    url: `${domainsPath(companyId)}/${domain}/url_fowarding/${host}`,
    method: 'DELETE'
  })
}

/**
 * Create a domain URL forwarder
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function createCompanyDomainForwardingData(companyId, domain, data) {
  return Ajax.request({
    url: `${domainsPath(companyId)}/${domain}/url_fowarding`,
    method: 'POST',
    data: data
  })
}

/**
 * Update a domain URL forwarder
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function updateCompanyDomainForwardingData(companyId, domain, data) {
  return Ajax.request({
    url: `${domainsPath(companyId)}/${domain}/url_fowarding`,
    method: 'PUT',
    data: data
  })
}

// /**
//  * Update a company
//  *
//  * @param {string} id
//  * @param {object} company
//  * @param {string} company.name
//  *
//  * @returns {promise}
//  */
// export function updateCompanyData(id, company) {
//   return Ajax.request({
//     url: `${domainsPath(companyId}/${id}`,
//     method: 'PATCH',
//     data: {company}
//   })
// }

// /**
//  * Delete a company
//  *
//  * @param {string} id
//  *
//  * @returns {promise}
//  */
// export function deleteCompanyData(id) {
//   return Ajax.request({
//     url: `${domainsPath(companyId}/${id}`,
//     method: 'DELETE'
//   })
// }
